<div class="sticky top-16 z-[30] bg-white pb-2">
  <nav compact tuiSubheader class="bg-white">
    <tui-breadcrumbs [itemsLimit]="10">
      <ng-container *ngFor="let item of breadcrumbs; let last = last">
        <ng-container *ngIf="last">
          <strong *tuiItem tuiFade>
            {{ item }}
          </strong>
        </ng-container>
        <ng-container *ngIf="!last">
          <button *tuiItem tuiLink type="button">
            {{ item }}
          </button>
        </ng-container>
      </ng-container>
    </tui-breadcrumbs>
  </nav>

  <div class="items-center flex justify-between">
    <p class="text-[1.25rem] font-bold mt-[0.9rem] text-[#000000A6]">Clients</p>
    <button [routerLink]="['/admin/client/add-edit']" tuiButton type="button" size="s">
      Add New Client
    </button>
  </div>

  <!-- Top Row: Search Inputs -->
  <div class="flex items-center space-x-4 mb-4">
    <div class="w-[300px]">
      <tui-textfield iconStart="@tui.search" tuiTextfieldSize="m">
        <input [(ngModel)]="filters.searchText" (keydown)="onEnter($event)" placeholder="Search Clients" tuiTextfield />
      </tui-textfield>
    </div>

    <!-- Status dropdown -->
    <div class="w-[160px]">
      <tui-combo-box tuiTextfieldSize="m" [stringify]="stringify" [(ngModel)]="filters.status"
        (ngModelChange)="applyFilters({ status: filters.status })">
        Status
        <input tuiTextfieldLegacy placeholder="Select status" [value]="stringify(filters.status)" />
        <tui-data-list-wrapper *tuiDataList [items]="items" [itemContent]="stringify | tuiStringifyContent" />
      </tui-combo-box>
    </div>

    <!-- Client Type dropdown -->
    <div class="w-[180px]">
      <tui-combo-box tuiTextfieldSize="m" [stringify]="stringifyClientType" [(ngModel)]="filters.clientType"
        (ngModelChange)="applyFilters({ clientType: filters.clientType })">
        Client Type
        <input tuiTextfieldLegacy placeholder="All Types" [value]="stringifyClientType(filters.clientType)" />
        <tui-data-list-wrapper *tuiDataList [items]="clientTypeItems"
          [itemContent]="stringifyClientType | tuiStringifyContent" />
      </tui-combo-box>
    </div>

    <button (click)="loadClients()" appearance="secondary" size="m" tuiButton type="button" class="w-full sm:w-auto"
      style="border: 2px solid #e5e7ea; font-weight: 800">
      Search
    </button>
  </div>
</div>

<!-- Main Search & Filter Container -->
<section class="w-full">

  <!-- Bottom Row: Results Info (Left) and Archive Toggle (Right) -->
  <div class="flex items-center justify-between w-full">
    <!-- Left Side: Result Text & Clear -->
    <div class="flex items-center space-x-4">
      <p class="text-sm font-semibold text-[#26293C] my-0">
        Showing results for "{{ filters.searchText || "All Clients" }}"
      </p>
      <button appearance="flat" iconStart="@tui.rotate-cw" size="xs" tuiButton type="reset" (click)="clearSearch()">
        Clear
      </button>
    </div>

    <!-- Right Side: Archived Toggle -->
    <div class="flex items-center space-x-2">
      <p class="text-sm font-medium text-[#191C30E5] my-0">Show Archived</p>
      <input title="Archived switch" tuiSwitch type="checkbox" [(ngModel)]="filters.archived"
        (change)="applyFilters({ archived: filters.archived })" />
    </div>
  </div>
</section>

<div *ngIf="isLoading" class="h-[400px]">
  <tui-loader />
</div>

<!-- Bulk-action bar: visible whenever the user has at least one row selected -->
<div *ngIf="!isLoading && selectionCount() > 0"
  class="flex items-center justify-between mt-4 p-3 rounded-md bg-[#F9FBFF] border border-[#E5E7EA]">
  <p class="text-sm font-medium text-[#191C30E5] m-0">
    {{ selectionCount() }} selected
  </p>
  <div class="flex items-center space-x-2">
    <button size="xs" appearance="secondary" tuiButton type="button" [disabled]="bulkBusy"
      [appDisableUnlessPermission]="'CLIENT_UPDATE'" (click)="bulkArchiveSelected(true)">
      Archive selected
    </button>
    <button size="xs" appearance="secondary" tuiButton type="button" [disabled]="bulkBusy"
      [appDisableUnlessPermission]="'CLIENT_UPDATE'" (click)="bulkArchiveSelected(false)">
      Unarchive selected
    </button>
    <button size="xs" appearance="secondary" tuiButton type="button" (click)="exportSelectedToCsv()">
      Export CSV
    </button>
  </div>
</div>

<div *ngIf="!isLoading" class="w-full mt-5 overflow-x-scroll">
  <table tuiTable [size]="size" class="w-full min-w-[1100px]">
    <thead>
      <tr>
        <th tuiTh style="
            padding: 0;
            padding-left: 10px;
            background-color: #f9fbff;
            width: 40px;
          ">
          <input type="checkbox" title="Select all on this page" [checked]="isAllSelected()"
            (change)="toggleSelectAll($any($event.target).checked)" />
        </th>
        <th tuiTh style="
        width: 150px;
            padding: 0;
            padding-left: 10px;
            background-color: #f9fbff;
          ">
          Identifier
        </th>
        <th tuiTh style="
            padding: 0;
            padding-left: 10px;
            background-color: #f9fbff;
          ">
          Client Type
        </th>
        <th tuiTh style="
            padding: 0;
            padding-left: 10px;
            background-color: #f9fbff;
          ">
          Client Name
        </th>
        <th tuiTh style="
            padding: 0;
            padding-left: 10px;
            background-color: #f9fbff;
          ">
          Patient Name
        </th>
        <th tuiTh style="
            padding: 0;
            padding-left: 10px;
            background-color: #f9fbff;
          ">
          Client Contact No
        </th>
        <th tuiTh style="
            padding: 0;
            padding-left: 10px;
            background-color: #f9fbff;
          ">
          Registration Type
        </th>
        <th tuiTh style="
            padding: 0;
            padding-left: 20px;
            background-color: #f9fbff;
          ">
          Status
        </th>
        <th tuiTh style="
            padding: 0;
            padding-left: 10px;
            background-color: #f9fbff;
          ">
          Created Date
        </th>
        <th tuiTh style="
            padding: 0;
            padding-left: 10px;
            background-color: #f9fbff;
          ">
          Actions
        </th>
      </tr>
    </thead>

    <tbody tuiTbody>
      <tr *ngFor="let user of clientData">
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <input type="checkbox" [title]="'Select ' + (user?.name || 'client')" [checked]="isSelected(user._id)"
            (change)="toggleSelected(user._id, $any($event.target).checked)" />
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p [routerLink]="['/admin/client/', user._id]" class="text-[#526ED3] text-sm cursor-pointer">
              {{ getClientIdentifier(user) }}
            </p>
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <p class="text-center px-2 py-1 rounded-full text-white w-fit px-3 text-xs font-medium"
            [ngStyle]="{ 'background-color': getClientTypeBgColor(user.clientType) }">
            {{ getClientTypeLabel(user?.clientType) }}
          </p>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p class="text-[#191C30E5] text-sm">{{ user?.guardianName }}</p>
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p class="text-[#191C30E5] text-sm">{{ user.name }}</p>
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p class="text-[#191C30E5] text-sm">
              {{ user?.guardianContactNo }}
            </p>
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <p class="text-center py-1 rounded-full text-white w-fit px-2 text-xs"
            [ngStyle]="{ 'background-color': getClientTypeBgColor(user?.clientType) }">
            {{ getRegistrationTypeLabel(user) }}
          </p>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <p class="text-center  py-0.5 px-2 rounded-full text-white"
            [style.background-color]="user.active ? '#6BC68A' : 'red'">
            {{ user.active ? "Active" : "Inactive" }}
          </p>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <div [tuiCell]="size">
            <p class="text-[#191C30E5] text-sm">
              {{ user.createdAt | date : "MMM d, y" }}
            </p>
          </div>
        </td>
        <td tuiTd style="padding-top: 0px; padding-bottom: 0px">
          <span tuiStatus>
            <p [routerLink]="['/admin/client/', user._id]"
              class="text-[#526ED3] underline decoration-dotted underline-offset-4 hover:text-blue-800 cursor-pointer">
              View
            </p>
            <button [routerLink]="['/admin/client/add-edit', user._id]" [disabled]="user?.archived" [style.color]="
                user?.archived
                  ? '#a6afce'
                  : loggedInUserCanEdit
                  ? '#526ED3'
                  : '#a6afce'
              "
              class="appearance-none bg-white border-none pt-[3px] m-0 text-[#526ED3] underline decoration-dotted underline-offset-4 hover:text-blue-800 cursor-pointer">
              Edit
            </button>
            <div>
              <button appearance="action" iconStart="@tui.ellipsis" size="xs" tuiIconButton type="button"
                [tuiAppearanceState]="openMap[user._id] ? 'hover' : null" [tuiDropdown]="content"
                [disabled]="!loggedInUserCanEdit" [style.color]="!loggedInUserCanEdit ? '#a6afce' : '#526ED3'"
                [(tuiDropdownOpen)]="openMap[user._id]" (click)="toggleDropdown(user._id)">
                More
              </button>
              <ng-template #content>
                <tui-data-list tuiDataListDropdownManager [size]="openDropdownsize">
                  <button style="color: black" class="dropdown-button" tuiOption type="button"
                    *ngIf="user?.clientType !== 'Inward' && user?.clientType !== 'Unregistered'"
                    (click)="resetUserPassword(user?.email)">
                    Reset Password
                  </button>
                  <button style="color: black" class="dropdown-button" tuiOption type="button"
                    (click)="toggleActive(user?._id)">
                    {{ user?.active ? "Deactivate" : "Activate" }}
                  </button>
                  <button *ngIf="!user?.archived || canUnarchiveClient(user)" style="color: black"
                    class="dropdown-button" tuiOption type="button" (click)="toggleArchive(user?._id)">
                    {{ user?.archived ? "Unarchive" : "Archive" }}
                  </button>
                  <button *ngIf="!user?.archived" style="color: black" class="dropdown-button" tuiOption type="button"
                    [appDisableUnlessPermission]="'CLIENT_UPDATE'" (click)="openChangeClientType(user)">
                    Change client type
                  </button>
                </tui-data-list>
              </ng-template>
            </div>
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<app-change-client-type-panel [open]="changeTypeDialogOpen" [client]="changeTypeClient" [busy]="changeTypeBusy"
  (openChange)="changeTypeDialogOpen = $event" (confirm)="onChangeTypeConfirm($event)"
  (cancel)="onChangeTypeCancel()" />

<!-- Pagination Controls -->
<div class="flex justify-end items-center mt-5">
  <tui-pagination [index]="pageIndex - 1" [length]="getPageCount()" (indexChange)="onPageChange($event + 1)">
  </tui-pagination>
</div>